import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { firstValueFrom, lastValueFrom, map, Observable } from 'rxjs';
import Keycloak from 'keycloak-js';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly _http = inject(HttpClient);
  private readonly _keycloak = inject(Keycloak);
  private sanitizer = inject(DomSanitizer);

  constructor() {}

  getVersion() {
    return this._http.get(environment.hasura.storage + '/version');
  }

  getFile(id: string, name: string) {
    return this._http
      .get(environment.hasura.storage + '/files/' + id, {
        responseType: 'blob',
      })
      .pipe(
        map((blob: any) => {
          let objectURL = URL.createObjectURL(blob);
          return {
            file: new File(
              [blob as any], // cast as any
              name,
              {
                lastModified: new Date().getTime(),
                type: blob.type,
              },
            ),
            ...(blob.type.startsWith('image')
              ? { objectURL: this.sanitizer.bypassSecurityTrustUrl(objectURL) }
              : {}),
          };
        }),
      );
  }

  scarica(file: any) {
    const newWindow = window.open('', '_blank'); // apre subito la finestra

    if (!newWindow) {
      alert(
        'Impossibile aprire la finestra. Controlla che il blocco pop-up sia disattivato.',
      );
      return;
    }

    this.getFile(file.id, file.name!).subscribe((res) => {
      const url = URL.createObjectURL(res?.file as any);
      newWindow.location.href = url;
    });
  }

  getFileUrl(id: string) {
    return this._http
      .get(environment.hasura.storage + '/files/' + id, {
        responseType: 'blob',
      })
      .pipe(map((blob) => URL.createObjectURL(blob)));
  }
  async uploadFile(files: File[], metadata: { [key: string]: string }) {
    const token = await this._keycloak.token;

    const formData = new FormData();
    // formData.append('bucket-id', bucket);
    files.forEach((file) => {
      formData.append('file[]', file);
      formData.append(
        'metadata[]',
        JSON.stringify({
          metadata,
        }),
      );
    });

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      // 'x-hasura-admin-secret': '8vo13Rr8S9U8',
    });

    return this._http.post(environment.hasura.storage + '/files', formData, {
      headers,
    });
  }
}
